import React from 'react';
import * as styles from './styles.scss';

const Column = ({ html, label }) => (
    <div
        className={`${styles.col}${!!label ? ` ${styles.label}` : ''}`}
        { ...(label ? { 'data-label': label } : {}) }
    >
        {html}
    </div>
);

export default Column;
